import { Province } from '../../Models/province';

export const PROVINCES: any[] = [
  {
    provinceId: 1,
    provinceTitle: "East Azerbaijan Province",
    provincePersianTitle: "آذربایجان شرقی",
    country: null
  },
  {
    provinceId: 2,
    provinceTitle: "West Azerbaijan Province",
    provincePersianTitle: "آذربایجان غربی",
    country: null
  }, {
    provinceId: 3,
    provinceTitle: "Ardabil Province",
    provincePersianTitle: "اردبیل",
    country: null
  }, {
    provinceId: 4,
    provinceTitle: "Isfahan Province",
    provincePersianTitle: "اصفهان",

    country: null
  }, {
    provinceId: 5,
    provinceTitle: "Alborz Province",
    provincePersianTitle: "البرز",
    country: null
  }, {
    provinceId: 6,
    provinceTitle: "Ilam Province",
    provincePersianTitle: "ایلام",
    country: null
  }, {
    provinceId: 7,
    provinceTitle: "Bushehr Province",
    provincePersianTitle: "بوشهر",
    country: null
  }, {
    provinceId: 8,
    provinceTitle: "Tehran Province",
    provincePersianTitle: "تهران",
    country: null
  }, {
    provinceId: 9,
    provinceTitle: "Chaharmahal and Bakhtiari Province",
    provincePersianTitle: "چهارمحال وبختیاری",
    country: null
  }, {
    provinceId: 10,
    provinceTitle: "South Khorasan Province",
    provincePersianTitle: "خراسان جنوبی",
    country: null
  }, {
    provinceId: 11,
    provinceTitle: "Razavi Khorasan Province",
    provincePersianTitle: "خراسان رضوی",
    country: null
  }, {
    provinceId: 12,
    provinceTitle: "North Khorasan Province",
    provincePersianTitle: "خراسان شمالی",
    country: null
  }, {
    provinceId: 13,
    provinceTitle: "Khuzestan Province",
    provincePersianTitle: "خوزستان",

    country: null
  }, {
    provinceId: 14,
    provinceTitle: "Zanjan Province",
    provincePersianTitle: "زنجان",
    country: null
  }, {
    provinceId: 15,
    provinceTitle: "Semnan Province",
    provincePersianTitle: "سمنان",
    country: null
  }, {
    provinceId: 16,
    provinceTitle: "Sistan and Baluchestan Province",
    provincePersianTitle: "سیستان وبلوچستان",
    country: null
  }, {
    provinceId: 17,
    provinceTitle: "Fars Province",
    provincePersianTitle: "فارس",
    country: null
  }, {
    provinceId: 18,
    provinceTitle: "Qazvin Province",
    provincePersianTitle: "قزوین",
    country: null
  }, {
    provinceId: 19,
    provinceTitle: "Qom Province",
    provincePersianTitle: "قم",
    country: null
  }, {
    provinceId: 20,
    provinceTitle: "Kermanshah Province",
    provincePersianTitle: "کرمانشاه",
    country: null
  }, {
    provinceId: 21,
    provinceTitle: "Kurdistan Province",
    provincePersianTitle: "کردستان",
    country: null
  }, {
    provinceId: 22,
    provinceTitle: "Kerman Province",
    provincePersianTitle: "کرمان",
    country: null
  }, {
    provinceId: 23,
    provinceTitle: "Kohgiluyeh and Boyer-Ahmad Province",
    provincePersianTitle: "کهگیلویه وبویراحمد",
    country: null
  }, {
    provinceId: 24,
    provinceTitle: "Golestan Province",
    provincePersianTitle: "گلستان",
    country: null
  }, {
    provinceId: 25,
    provinceTitle: "Gilan Province",
    provincePersianTitle: "گیلان",
    country: null
  }, {
    provinceId: 26,
    provinceTitle: "Lorestan Province",
    provincePersianTitle: "لرستان",
    country: null
  }, {
    provinceId: 27,
    provinceTitle: "Mazandaran Province",
    provincePersianTitle: "مازندران",
    country: null
  }, {
    provinceId: 28,
    provinceTitle: "Markazi Province",
    provincePersianTitle: "مرکزی",
    country: null
  }, {
    provinceId: 29,
    provinceTitle: "Hormozgan Province",
    provincePersianTitle: "هرمزگان",
    country: null
  }, {
    provinceId: 30,
    provinceTitle: "Hamadan Province",
    provincePersianTitle: "همدان",
    country: null
  }, {
    provinceId: 31,
    provinceTitle: "Yazd Province",
    provincePersianTitle: "یزد",
    country: null
  },
]
